/**
 * Extrae el número de un string con formato chileno (puntos como miles, coma como decimal).
 * Devuelve un número (entero o decimal según el caso).
 * Ejemplos:
 *   "$112.308.919" => 112308919
 *   "1.234,56"     => 1234.56
 */
export const extraerNumeroDesdeString = (numeroString: string) =>  {
  // Elimina todo lo que no sea dígito, punto o coma
  let soloNumeros = numeroString.replace(/[^0-9.,-]+/g, '').trim();

  // Quita todos los puntos (separador de miles)
  soloNumeros = soloNumeros.replace(/\./g, '');

  // Cambia la coma por punto para que JS lo entienda como decimal
  soloNumeros = soloNumeros.replace(',', '.');

  // Convierte a número
  const numero = Number(soloNumeros);

  return isNaN(numero) ? null : numero;
}